import React, { createContext, useState, useContext } from 'react';

// Create Context
const MenuContext = createContext();

// Create a Provider Component
export const MenuProvider = ({ children }) => {
  const [selectedSubItem, setSelectedSubItem] = useState(localStorage.getItem("currentPage") || '');

  const handleSubMenuItemClick = (item) => {
    localStorage.setItem("currentPage", item); // Store the selected item in localStorage
    setSelectedSubItem(item); // Update the selected submenu item
  };

  return (
    <MenuContext.Provider value={{ selectedSubItem, handleSubMenuItemClick }}>
      {children}
    </MenuContext.Provider>
  );
};

// Custom hook to use MenuContext in any component
export const useMenu = () => useContext(MenuContext);
